import { NgModule } from "@angular/core";

import { Routes, RouterModule} from "@angular/router";
import { NotFoundComponent } from "./core/shared/components/not-found/not-found.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { LockGuard } from "./core/guards/lock.guard";

const routes: Routes = [
  { path: 'configuration', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/configuration/configuration.module').then(m =>m.ConfigurationModule)},
  { path: 'external', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/ambulatory-care/ambulatory-care.module').then(m =>m.AmbulatoryCareModule)},
  { path: 'hospitalization', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/hospitalization/hospitalization.module').then(m =>m.HospitalizationModule)},
  { path: 'emergency', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/emergencies/emergencies.module').then(m =>m.EmergenciesModule)},
  { path: 'cross-functions', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/cross-functions/cross-functions.module').then(m =>m.CrossFunctionsModule)},
  { path: 'patients', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('../app/inside/patients/patients.module').then(m =>m.PatientsModule)},
  { path: 'operating-room', canActivate: [AuthGuard, LockGuard], loadChildren: () => import('./inside/operating-room/operating-room.module').then(m =>m.OperatingRoomModule)},
  { path: '', loadChildren: () => import('./public/public.module').then(m =>m.PublicModule)},
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule{}
